<template>
  <main>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-10"></div>
      <div class="md-layout-item md-size-80 md-small-size-100">
        <md-card>
          <md-card-header>
            <div class="md-title">ご利用上の注意</div>
          </md-card-header>

          <md-card-content>
            <md-table md-card>
              <md-table-row>
                <md-table-cell>
                  ■本契約時には登記情報提供サービスのIDが必要です。<br/>
                  <span class="md-caption">※シカクマップ1IDにつき登記情報提供サービス1IDが必要です。</span><br/>
                  本サービスでの操作中は本サービスのみでご使用いただきますようお願い申し上げます。本サービス以外で使用（登記情報提供サービスで直接使用することを含む）したことにより生じたいかなる損害についても、JONは一切の責任を負わないものとします。（<router-link :to="{name:'Terms'}">規約</router-link>より）
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell>
                  ■ユーザ１人につきシカクマップID1個を、当該ユーザの専用端末によりご使用ください。複数のユーザ・端末で1個のIDを共用することはできません。（メインとなるデスクトップ端末1台及びユーザを同じくするモバイル端末1台の範囲とします。）<br/>
                  特別に共用が認められる場合については
                  <router-link :to="{name:'Terms'}">規約</router-link>
                  をご確認ください。
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell>
                  ■未入金が発生した場合、ご入金の確認が取れるまでアカウントを停止させていただく場合がございます。
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell>
                  ■毎月自動更新となります。解約のお手続きにつきましては
                  <router-link :to="{name:'Terms'}">規約</router-link>
                  をご確認ください。
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell>
                  ■JON地番地図は精度や鮮度、網羅性について、完全性を保証するものではございません。<br/>
                  弊社グループの保有する現状有姿による提供をご了承ください。
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell>
                  ■インターフェースデザイン等の仕様は、技術改善などのため予告なく変更する場合がございます。
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell>
                  ■本商品のご利用はご契約者様に限ります。本商品又は本商品により得られる情報の無断二次利用や、JONの事業利益を実質的に侵害する目的でのご利用はできません。<br/>
                  シカクマップの詳しいご利用条件については
                  <router-link :to="{name:'Terms'}">規約</router-link>
                  をご確認ください。
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell>
                  ■当サイトは「SSL」で個人情報が暗号化されているため安心してご利用いただけます。
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell>
                  ■登記情報の取得には、<a href="https://www1.touki.or.jp/use/index.html" rel="noopener" target="_blank">法人利用の登記情報提供サービスのID・パスワード</a>が必要です。
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell>
                  ■<router-link :to="{name:'Terms'}">規約</router-link> 第6条、第8条、第9条に本サービスの使用に関して記載しております。これらに則って、制約の一例として下記「①かつ②を満たす」または「③かつ④を満たす」利用をされていた場合、地番地図閲覧や地番検索に数十秒のスリープが発生いたします。<br/>
                  <br/>
                  ①（地番地図表示数‐登記情報取得数）＞100<br/>
                  ②（地番地図表示数／登記情報取得数）＞20 or 登記情報取得件数 = 0<br/>
                  ③（地番検索数‐登記情報取得数）＞200<br/>
                  ④（地番検索数／登記情報取得数）＞20 or 登記情報取得件数 = 0<br/>
                  <span class="md-caption">※各種件数はアカウント数（初月無料対象アカウント以外）で割ったものが対象になります</span><br/>
                  <span class="md-caption">※各種件数はメニューの利用状況でご確認いただけます</span><br/>
                  <br/>
                  上記を満たさなくなった場合、翌日には制約が解除されます。<br/>
                  また次月には一旦制約がリセットされますが、上記にかかる利用をされると再度利用が制限されます。
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>

          <md-card-content>
            <md-table md-card>
              <md-table-toolbar>
                <h1 class="md-title">ご利用料金</h1>
              </md-table-toolbar>
              <md-table-row>
                <md-table-cell class="title">月額</md-table-cell>
                <md-table-cell>
                  <p class="md-body-2">1ID ¥12,000</p>
                  <p>※2ID目以降は逓減的にアカウント単価が割安になります。詳しくは
                    <router-link :to="{name:'Simulation2'}">料金シミュレーション</router-link>
                    でご確認ください。
                  </p>
                  <p>※本契約後、IDの追加が可能です。1カ月間で有効となったIDの総数を基準とし、ご請求させていただきます。</p>
                  <p>※登記情報取得料金につきましては、登記情報提供サービス利用料として、一般財団法人民事法務協会様より請求されます。</p>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="title">手数料</md-table-cell>
                <md-table-cell>
                  <p>請求書郵送をご希望の場合：¥300/月</p>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="title">料金の発生について</md-table-cell>
                <md-table-cell>
                  <p>IDを発行された月から、ID数に応じた月額が発生致します。<br/>
                    月の途中でのID発行・利用解除・退会があっても、月額の日割計算は行いません。<br/>
                    ただし、2ヶ月目（IDを発行された翌月）までご契約を継続されたIDの月額につきましては、1ヶ月目を無料とさせて頂きます。（無料となったID数を控除して月額が計算されます。）</p>
                  <ul class="list-style-type-example">
                    <li>7/10に3IDご契約、8/1時点まで3IDご契約継続の場合：7月分月額は0円となります。</li>
                    <li>7/10に3IDご契約、7/20に1ID利用解除、8/1時点まで2IDご契約継続の場合：7月分月額は1ID分の12,000円となります。</li>
                  </ul>

                  <p class="mb-0">※IDの利用解除/利用再開について</p>
                  <ul class="list-style-type-none">
                    <li>利用解除したIDを利用再開する場合は、1ヶ月目無料の対象とはなりません。</li>
                  </ul>

                  <!--キャンペーン用-->
                  <!--
                  <p class="mb-0 campaign">※キャンペーン期間中のご契約につきまして、ご契約当月での退会・ID利用解除があった場合も1ヶ月目のご利用料金は発生しません。
                    ただし登記情報取得料金につきましては、登記情報提供サービス利用料として、一般財団法人民事法務協会様より請求されます。</p>
                  <ul class="list-style-type-none-no-nest campaign">
                    <li>キャンペーン期間：2020年12月1日～<s>2021年3月末(予定)</s> 2021年6月末(予定)<br/>ご好評につきキャンペーン期間を延長いたします。</li>
                  </ul>
                  -->
                </md-table-cell>
              </md-table-row>
            </md-table>
            <p class="md-caption md-layout md-alignment-center-right">※表示金額はすべて税抜です。</p>
          </md-card-content>

          <md-card-content>
            <md-table md-card>
              <md-table-toolbar>
                <h1 class="md-title">契約条件</h1>
              </md-table-toolbar>
              <md-table-row>
                <md-table-cell class="title">契約期間</md-table-cell>
                <md-table-cell>
                  <p>1ヶ月毎の自動更新</p>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="title">請求サイクル</md-table-cell>
                <md-table-cell>
                  <p>月末締め翌月払い</p>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="title">請求書送付方法</md-table-cell>
                <md-table-cell>
                  <p>メール／郵送</p>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="title">支払方法</md-table-cell>
                <md-table-cell>
                  <p class="md-body-2">クレジットカード／銀行振込</p>
                  <p>※当サイトの決済は決済代行会社「GMOペイメントゲートウェイ」を利用しております。</p>

                  <p class="md-body-2">●クレジットカード</p>
                  <p class="md-body-1">カード会社はVISA/Master/AMEX/JCB/DINERSからお選びいただくことができます。
                    <span class="md-caption">※手数料無料</span><br/>
                    <img src="https://cdn.jon-api.com/shikaku-map/img/cards.png" width="33%"></p>
                  <ul>
                    <li>各クレジットカード会社様の規約に基づいた期日に引き落としがされます。</li>
                    <li>お支払い回数は「一回払い」のみとさせていただきます。ご了承ください。</li>
                    <li>弊社から御請求書は発行いたしません。各クレジットカード会社様からのご利用明細・請求書等をご確認ください。</li>
                    <li>本商品のご利用詳細につきましては、本契約でログイン後ご確認いただくことが可能です。</li>
                    <li>本契約後、カード情報の変更は可能です。</li>
                  </ul>

                  <p class="md-body-2">●銀行振込</p>
                  <p class="md-body-1">弊社指定の金融機関の口座へお振込みください。</p>
                  <ul>
                    <li>各種金融機関振込手数料はお客様負担となります。</li>
                  </ul>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>

          <md-card-content>
            <md-table md-card>
              <md-table-row>
                <md-table-cell class="title">お問い合わせ</md-table-cell>
                <md-table-cell>
                  <p>受付時間： 9:00〜18:00（GW・年末年始を除く）</p>
                  <p>HP： <a href="https://www.jon.co.jp/contact/" rel="noopener" target="_blank">https://www.jon.co.jp/contact/</a>
                  </p>
                  <p>TEL： 03-6240-1229</p>
                  <p>メール： jon-web_info@jon.co.jp</p>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-size-10"></div>
    </div>
  </main>
</template>

<script>
import CommonMixin from "@/mixins/commonMixin";

export default {
    name   : "Payment",
    mixins: [CommonMixin],
  }
</script>

<style lang="scss" scoped>
  @import "src/assets/scss/components.scss";

  .md-table:nth-child(1) {
    .md-table-row {
      .md-table-cell.title {
        background: #eee;
      }

      .md-table-cell:nth-child(1) {
        width: 25%;
      }

      &:hover:not(.md-header-row) .md-table-cell:not(.title) {
        background: unset !important;
      }
    }
  }

  .list-style-type-example {
    list-style-type: none;
    margin-left: 1em;

    li {
      &:nth-child(1):before {
        content: '【例1】';
        display: inline-block;
        margin-left: -3.5em;
        width: 4.0em;
      }

      &:nth-child(2):before {
        content: '【例2】';
        display: inline-block;
        margin-left: -3.5em;
        width: 4.0em;
      }
    }
  }

  .list-style-type-none {
    list-style-type: none;
    margin-top: 0.1em;

    li {
      &:before {
        content: '';
        display: inline-block;
        margin-left: -2.0em;
        width: 0;
      }
    }
  }

  .list-style-type-none-no-nest {
    list-style-type: none;
    margin-top: 0.1em;
    margin-left: -2.0em;
  }

  .mb-0 {
    margin-bottom: 0;
  }

  .campaign {
    color: red;
  }
  .md-attention {
    color: #ff5252;
  }
</style>
